export const getSearchLoading = state => state.search.isLoading;
export const getSearchParameters = state => state.search.parameters;
export const getSearchBookResults = state => state.search.books;
export const getSearchUserResults = state => state.search.users;
export const getSearchAuthorHints = state => state.search.authorHints;
